import React, { InputHTMLAttributes } from 'react'
import clsx from 'clsx'
import styles from './styles/Switch.module.scss'

type SwitchProps = {
  label?: string
  justify?: boolean // justify with space between on row layout
} & InputHTMLAttributes<HTMLInputElement>

export const Switch: React.FC<SwitchProps> = props => {
  const { label, justify, disabled, ...rest } = props

  return (
    <label className={clsx(styles.field, disabled && styles.disabled, justify && styles.justify)}>
      <span>{label}</span>
      <input type="checkbox" disabled={disabled} {...rest} />
      <span className={clsx(styles.slider, styles.round, disabled && styles.disabled)}></span>
    </label>
  )
}
